import { Injectable } from "@angular/core";
import { Camera, CameraOptions } from "@ionic-native/camera";

@Injectable()
export class CameraProvider {
  defaultOptions: CameraOptions = {
    quality: 100,
    destinationType: this.camera.DestinationType.DATA_URL,
    encodingType: this.camera.EncodingType.JPEG,
    mediaType: this.camera.MediaType.PICTURE,
  };

  constructor(public camera: Camera) {}

  getPictureFromLibrary(inputOptions?: CameraOptions): Promise<any> {
    inputOptions = inputOptions || {};
    const options = Object.assign(inputOptions, {
      quality: 20,
      destinationType: this.camera.DestinationType.DATA_URL,
      sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
      encodingType: this.camera.EncodingType.PNG,
      targetWidth: 345,
      targetHeight: 264,
      allowEdit: true,
      saveToPhotoAlbum: false,
    });
    return this.getPicture(options);
  }

  getPictureFromCamera(inputOptions?: CameraOptions): Promise<any> {
    inputOptions = inputOptions || {};
    const options = Object.assign(inputOptions, {
      quality: 20,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.PNG,
      targetWidth: 345,
      targetHeight: 264,
      allowEdit: true,
      saveToPhotoAlbum: false,
    });
    return this.getPicture(options);
  }

  getPicture(inputOptions: CameraOptions): Promise<any> {
    const options = Object.assign(inputOptions, this.defaultOptions);
    console.log(options);
    return this.camera.getPicture(options);
  }

  toBlob(base64: string): Blob {
    const bin = atob(base64.replace(/^.*,/, ""));
    let buffer = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) {
      buffer[i] = bin.charCodeAt(i);
    }
    const blob = new Blob([buffer.buffer], { type: "image/png" });
    return blob;
  }
}



// WEBPACK FOOTER //
// ./src/providers/camera/camera.ts